import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartItem } from 'src/app/services/cart/cart.service';

@Component({
  selector: 'app-cart-item-card',
  templateUrl: './cart-item-card.component.html',
  styleUrls: ['./cart-item-card.component.css'],
})
export class CartItemCardComponent {
  @Input() item!: CartItem;

  @Output() remove = new EventEmitter<void>();
  @Output() incrementQty = new EventEmitter<void>();
  @Output() decrementQty = new EventEmitter<void>();
  @Output() addToFavorite = new EventEmitter<void>();
}
